import mockVenuesDataProvider from './mockVenuesDataProvider';
import backendVenuesDataProvider from './backendVenuesDataProvider';

const USE_MOCK_PROVIDER = false;

const provider = USE_MOCK_PROVIDER ? mockVenuesDataProvider : backendVenuesDataProvider;

export default provider;
